<template>
   <aside class="teachable-sidebar">
      <div class="teachable-sidebar-wrapper">
         <TOC class="teachable-toc" />
         <TeachableReview
            v-if="
               route.name == 'teachable' || route.name == 'core-work-teachable'
            "
         />
      </div>
   </aside>
</template>

<script setup lang="ts">
const route = useRoute();
</script>

<style lang="scss" scoped>
@import "~/assets/scss/teachable/teachable-sidebar";
</style>
